import { useMemo } from "react";
import { useJsApiLoader } from "@react-google-maps/api";

export const useGoogleMapsLoader = () => {
  return useJsApiLoader(
    useMemo(
      () => ({
        id: "google-maps-loader", // Consistent ID for all loaders
        googleMapsApiKey: process.env.REACT_APP_GMAPS_KEY,
        version: "weekly",
        libraries: ["places"],
        language: "iw", // Hebrew language for Israel
        region: "IL", // Israel region
      }),
      []
    )
  );
};
